export const JACKPOT_BET_ANALYTICS_CATEGORY: string = "JACKPOT_BETS";
export const JACKPOT_BET_TECH_EVENTS_CATEGORY: string = "JACKPOT_BETS_TECH";